<template>
  <header class="main-header">
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
  <router-link :to="{ name: 'ServiceMonitoring' }" class="logo-side2">
            <!-- mini logo for sidebar mini 50x50 pixels -->
              <img src="\static\img\icons\logo-navbar.png">
            </router-link>
   <!-- Boton que amplia el sidebar
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a> -->
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <!-- Fecha de hoy -->
          <label v-if="window.width > 400" class="fechaNav" style="text-transform:capitalize">{{new Date() | formatDate('dddd DD')}}</label>
          <label v-if="window.width > 400" class="fechaNav" style="padding-left:5px; padding-right:5px;">de</label>
          <label v-if="window.width > 400" class="fechaNav" style="text-transform:capitalize">{{new Date() | formatDate('MMM YYYY')}}</label>
        <ul class="nav navbar-nav">    
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu dropdown-per">
            <a href="#" class="dropdown-toggle nav-user-info" data-toggle="dropdown">
              <img src="/static/img/icons/icon-user-default.png" class="user-image" alt="User Image">
              <span class="hidden-xs user-info">{{ userInfo.name.toLowerCase().trim() }} </span><img src="/static/img/arrow-logo.png">
            </a>
            <ul class="dropdown-menu dropdown-menu-per" aria-labelledby="dropdownMenuLink"  aria-expanded="false" id="dropdownMenuButton">
              <!-- Menu Footer-->
              <li>
                <div class="pull-right">
                  <router-link :to="{ name: 'Logout' }" class="btn rectangle">
                    <i class="exit-icon"></i><p class="user-close">Cerrar Sesión</p>
                  </router-link>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  name: 'va-navibar',
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}

</script>



<style>

.main-header{
  width: 100%;
  position: fixed;
  z-index: 2;
}

.user-info {
  color:#6F6F6F;	
  font-size: 18px;		
  text-align: center;
  text-transform: capitalize;
}

.fechaNav{
  float: left;
  margin-top: 30px;
}

.navbar-nav {
  padding-top: 12px;
}
.navbar{
  display: inherit !important
}

.logo-side {
  background-color: #031A3C !important;
  width:71px !important;
  height: 71px;
  float: left;
  font-size: 20px;
  line-height: 50px;
  text-align: center;
  padding-top: 11px;
  
}

.logo-side2 {
  width:60px !important;
  height: 60px;
  float: left;
  font-size: 20px;
  line-height: 50px;
  text-align: center;
  margin-left: 10px;
  margin-top: 10px;
}

.sidebar-mini.sidebar-collapse .main-header .navbar{
  margin-left:  0px;
  border: 1px solid #E2E2E2; 
  }

.title-header{
  padding-left: 30px;
  height: 38px;
  width: auto;
	color: #364A5D;
	font-size: 32px;
	font-weight: 600;
	letter-spacing: -0.77px;
  line-height: 38px;
  float: left;
}

.nav>li.user>a>.fa{
  color:#6F6F6F !important;
  position:relative;
  top: -4px;
  font-size: 18px !important;
}


.dropdown-menu-per{
  background:none !important;
}

.rectangle {	
  height: 51px;	
  width: 157px;	
  border: 1px solid #E2E2E2;	
  border-radius: 0 0 0 5px;	
  background-color: #FFFFFF;
  text-align: center;
  padding-top: 14px;
  margin-top: 14px;
}

.rectangle:not(.dontHover):hover{
  animation-duration: 100s;
}

.exit-icon::before{
    content: url("/static/img/icons/sign-in-alt.png");
}

.user-close{
  display: inline;
  padding-left: 15px;
  position: relative;
  top: -3px;
  animation: none;
}

.skin-green .main-header .navbar .nav>li>a:not(.dontEnabled):enabled{
  background:none;
}

.skin-green .main-header .navbar .nav>li>a:not(.dontEnabled):hover{
  background:none;
}

.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{
  border: none !important;
}

@media (max-width: 767px){
.skin-green .main-header .navbar .dropdown-menu li a:hover {
    background-color: #FFFFFF;
}
}

@media (max-width: 991px){

  .main-header .navbar-custom-menu a, .main-header .navbar-right a{
    color: #3c8dbc !important;
    background-color: #FFFFFF;
  }
  .rectangle {	
    border: 1px solid #E2E2E2;	
    border-radius: 0 0 0 5px;	
    background-color: #FFFFFF;
    text-align: center;
    padding-top: 14px;
    margin-top: 0px;
  }

}

</style>



// WEBPACK FOOTER //
// NaviBar.vue?d98c8058